import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

export default function BarChart({ employeesData }: any) {
  // Custom color scheme for the bars
  const colors = ['#FF9900', '#33CC33', '#FF3366', '#800080 ']

  // Extracting data for each category for all employees
  console.log(employeesData, 'see heree employee leave')
  const ptoLeavesData = employeesData.map(
    (employee: any) => employee.total_pto_leaves,
  )
  const emergencyPTOData = employeesData.map(
    (employee: any) => employee.total_emergency_pto_leaves,
  )
  const workFromHomeData = employeesData.map(
    (employee: any) => employee.total_work_from_home,
  )
  const employeeNames = employeesData.map(
    (employee: any) => employee.employee_name,
  )
  const employeeLossOfPay = employeesData.map(
    (employee: any) => employee.total_loss_of_pay,
  )
  // Configuration for the grouped bar chart
  const options = {
    chart: {
      type: 'column', // Grouped bar chart type
      backgroundColor: 'black',
    },
    title: {
      text: 'Employee Leave Chart',
      style: {
        color: 'white',
      },
    },
    xAxis: {
      categories: employeeNames,
      labels: {
        style: {
          color: 'white',
        },
      },
    },
    yAxis: {
      title: {
        text: 'Leave Count',
        style: {
          color: 'white',
        },
        max: 50,
      },
      labels: {
        style: {
          color: 'white',
        },
      },
    },
    legend: {
      itemStyle: {
        color: 'white',
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    series: [
      {
        name: 'PTO Leaves',
        data: ptoLeavesData,
        color: colors[0],
      },
      {
        name: 'Emergency PTO',
        data: emergencyPTOData,
        color: colors[1],
      },
      {
        name: 'Work from Home',
        data: workFromHomeData,
        color: colors[2],
      },
      {
        name: 'Loss Of Pay',
        data: employeeLossOfPay,
        color: colors[3],
      },
    ],
  }

  return (
    <div
      style={{
        width: '80vw',
        margin: '0 auto',
      }}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}
